import { createContext, useContext, useState } from 'react'

type FactsSyncContextType = {
	isSyncing: boolean
	startSync: () => void
	endSync: () => void
}

const FactsSyncContext = createContext<FactsSyncContextType | undefined>(
	undefined,
)

export function FactsSyncProvider({ children }: { children: React.ReactNode }) {
	const [isSyncing, setIsSyncing] = useState(false)

	const startSync = () => setIsSyncing(true)
	const endSync = () => setIsSyncing(false)

	return (
		<FactsSyncContext.Provider value={{ isSyncing, startSync, endSync }}>
			{children}
		</FactsSyncContext.Provider>
	)
}

export function useFactsSync() {
	const context = useContext(FactsSyncContext)
	if (context === undefined) {
		throw new Error('useFactsSync must be used within a FactsSyncProvider')
	}
	return context
}
